export const FILE_START = '/report-file/upload/start';

export const FILE_FINISH = '/report-file/upload/finish';

export const SUBMIT_REPORT = '/submit-report';

export const IS_ATTACHMENT = 0;
export const CasemanagerAttachment = {
  MAX_FILE_SIZE: 1 * 1024 * 1024 * 1024, // 1 GB
  ALLOWED_EXTENSIONS: [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'pdf',
    'docx',
    'xlsx',
    'txt',
    'csv',
    'mp4',
    'mov',
    'ost',
    'pst',
  ],
};

export const IS_VOICE_RECORDING = 1;

export const CLOSED_REPORTS_STATUS_BOUNDARY = 2; //Reports in the closed or archived status range from 3-6, an Open Status is from 0-2

export const Status = {
  NEW_REPORT: 0,
  UNDER_REVIEW: 1,
  PENDING_FURTHER_INFORMATION: 2,
  CLOSED_RESOLVED: 3,
  CLOSED_NOT_ENOUGH_INFORMATION: 4,
  CLOSED_WHISTLEBLOWER_INITIATED: 5,
  ARCHIVED: 6,
};

export const ClosedStatuses = [
  Status.CLOSED_RESOLVED,
  Status.CLOSED_NOT_ENOUGH_INFORMATION,
  Status.CLOSED_WHISTLEBLOWER_INITIATED,
  Status.ARCHIVED,
];

export const NON_WB_REPORT_TYPES = [
  'Human Resources Report',
  'HR Report',
  'Feedback',
  'Complaints',
];
